import { HttpHeaders, HttpClient, HttpParams } from "@angular/common/http";
import { JWT_RESPONSE_HEADER } from "./constantes";
import { Observable } from "rxjs";
import { Injectable } from "@angular/core";

export interface IRequestOptions {
    headers?: HttpHeaders;
    observe?: 'body';
    params?: HttpParams;
    reportProgress?: boolean;
    responseType?: 'json';
    withCredentials?: boolean;
    body?: any;
}

export function applicationHttpClientCreator(http: HttpClient) {
    return new UHttpsClient(http);
}

@Injectable()
export class UHttpsClient {

    public constructor(public http: HttpClient) {
    }

    private obtenerUrlPorAmbiente(ruta: string | Request): string {
        const url = `${ruta}`;
        return url;
    }

    private appendAuthHeader(options?: IRequestOptions): IRequestOptions {
        let mergedOptions: IRequestOptions;

        if (!options) {
            mergedOptions = { headers: new HttpHeaders({JWT_RESPONSE_HEADER: sessionStorage.getItem(JWT_RESPONSE_HEADER)}) };
        } else {
            options.headers = options.headers.set(JWT_RESPONSE_HEADER, sessionStorage.getItem(JWT_RESPONSE_HEADER));
            mergedOptions = options;
            if (!options.headers) {
                mergedOptions.headers = new HttpHeaders();
            }
        }
        
        return mergedOptions;
    }

    public get<T>(url: string, options?: IRequestOptions): Observable<T> {
        return this.http.get<T>(this.obtenerUrlPorAmbiente(url), this.appendAuthHeader(options));
    }

    public post<T>(url: string, body: any, options?: IRequestOptions): Observable<T> {
        return this.http.post<T>(this.obtenerUrlPorAmbiente(url), body, this.appendAuthHeader(options));
    }

    public put<T>(url: string, body: any, options?: IRequestOptions): Observable<T> {
        return this.http.put<T>(this.obtenerUrlPorAmbiente(url), body, this.appendAuthHeader(options));
    }

    public delete<T>(url: string, options?: IRequestOptions): Observable<T> {
        return this.http.delete<T>(this.obtenerUrlPorAmbiente(url), this.appendAuthHeader(options));
    }
}
